import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Work } from '../data/WorkData';
import WorkList from '../subComponents/WorkList';
import SocialIcons from '../subComponents/SocialIcons';
import Exit from '../subComponents/Exit';
import { WorkLogo } from './Svgs';
import { NavLink } from 'react-router-dom';

const Container = styled.div`
  background: ${(props) => props.theme.gradientbg};
  position: relatve;
  display: flex;
  height: 780vh;
  align-items: center;



  @media (max-width: 420px) {
    height: 500vh;
  }

  
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 22%;
  left: calc(5rem + 6vw);
  height: 40vh;
  display: flex;

  @media (max-width: 744px) {
    left: calc(5rem + 5vw);
  }

  @media (max-width: 570px) {
    left: 10%;
  }
`;

const Rotate = styled.span`
  display: block;
  position: fixed;
  bottom: -20%;
  left: 40%;
  width: 350px;
  height: 350px;
  z-index: 0;
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.05)`};
`;

const Navigate = styled(motion.div)`
  position: fixed;
  display: flex;
  flex-direction: column;
  right: -5%;
  top: 0%;
  color: ${(props) => props.theme.text};

  span {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: calc(1rem + 1vw);
    border-bottom: 1px solid;
    margin-right: 58%;
  }

  @media (max-width: 600px) {
    right: -7%;

    span {
      margin-right: 48%;
    }
  }

  @media (max-width: 420px) {
    right: -9%;
  }
`;

const Contact = styled(NavLink)`
  display: flex;
  flex-direction: column;
  color: inherit;
  font-size: calc(1.5rem + 2vw);
  margin: 2rem;
  text-decoration: none;
`;

const About = styled(NavLink)`
  display: flex;
  flex-direction: column;
  color: inherit;
  font-size: calc(1.5rem + 2vw);
  margin: 2rem;
  text-decoration: none;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5
    }
  }
};

const WorkPage = () => {
  const ref = useRef(null);
  const worklogo = useRef(null);

  useEffect(() => {
    let element = ref.current;

    const rotate = () => {
      element.style.transform = `translateX(${-window.pageYOffset}px)`;

      return (worklogo.current.style.transform =
        `rotate(` + -window.pageYOffset + `deg)`);
    };

    window.addEventListener('scroll', rotate);

    return () => window.removeEventListener('scroll', rotate);
  }, []);

  return (
    <Container>
      <motion.div exit={{ opacity: 0 }}>
        <Exit />
        <SocialIcons />
        <Rotate ref={worklogo}>
          <WorkLogo fill="currentColor" />
        </Rotate>

        <Main ref={ref} variants={container} initial="hidden" animate="show">
          {Work.map((d) => (
            <WorkList key={d.id} data={d} />
          ))}
          <Navigate
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: 20 } }}
          >
            <Contact to="/contact" exact>
              <span>LET'S TALK</span>
              <h1>Contact</h1>
            </Contact>
            <About to="/about" exact>
              <span>ABOUT ME</span>
              <h1>About</h1>
            </About>
          </Navigate>
        </Main>
      </motion.div>
    </Container>
  );
};

export default WorkPage;
